import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import {
  AngleDown,
  AngleDownMobile,
  ClockIcon,
  DownIcon,
  LogoutIcon,
  UserIcon,
} from "../icons";
import { endUserSession } from "../services/auth.service";
import { useMediaQuery } from "react-responsive";
import React, { useEffect, useState } from "react";
import Modal from "react-modal";

export default function Header() {
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.user);
  var imageBasePath =
    window.location.protocol + "//" + window.location.host + "/";
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const [japanTime, setJapanTimes] = useState("");

  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [isDropdownOpenAbout, setDropdownOpenAbout] = useState(false);
  const [isDropdownOpenSerivces, setDropdownOpenSerivcs] = useState(false);
  const [isDropdownOpenAuction, setDropdownOpenAuction] = useState(false);
  const [openSubMenu, setOpenSubMenu] = useState(false);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (isDropdownOpen && !e.target.closest(".custom-select-6")) {
        setDropdownOpen(false);
      }
    };

    window.addEventListener("click", handleClickOutside);
    return () => {
      window.removeEventListener("click", handleClickOutside);
    };
  }, [isDropdownOpen]);

  useEffect(() => {
    const handleClickOutsideAbout = (e) => {
      if (isDropdownOpenAbout && !e.target.closest(".custom-select-2")) {
        setDropdownOpenAbout(false);
      }
    };

    window.addEventListener("click", handleClickOutsideAbout);
    return () => {
      window.removeEventListener("click", handleClickOutsideAbout);
    };
  }, [isDropdownOpenAbout]);

  useEffect(() => {
    const handleClickOutsideSerivces = (e) => {
      if (isDropdownOpenSerivces && !e.target.closest(".custom-select-3")) {
        setDropdownOpenSerivcs(false);
      }
    };

    window.addEventListener("click", handleClickOutsideSerivces);
    return () => {
      window.removeEventListener("click", handleClickOutsideSerivces);
    };
  }, [isDropdownOpenSerivces]);

  useEffect(() => {
    const handleClickOutsideAuction = (e) => {
      if (isDropdownOpenAuction && !e.target.closest(".custom-select-4")) {
        setDropdownOpenAuction(false);
      }
    };

    window.addEventListener("click", handleClickOutsideAuction);
    return () => {
      window.removeEventListener("click", handleClickOutsideAuction);
    };
  }, [isDropdownOpenAuction]);

  let subtitle;

  function closeModal() {
    setIsOpen(false);
  }

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "70vw",
      boxShadow:
        "0 2.8px 2.2px rgba(0, 0, 0, 0.02), 0 6.7px 5.3px rgba(0, 0, 0, 0.028), 0 12.5px 10px rgba(0, 0, 0, 0.035),0 22.3px 17.9px rgba(0, 0, 0, 0.042), 0 41.8px 33.4px rgba(0, 0, 0, 0.05), 0 100px 80px rgba(0, 0, 0, 0.07)",
      borderRadius: 12,
      padding: "0px",
    },
  };

  function afterOpenModal() {
    if (subtitle) subtitle.style.color = "#f00";
  }

  const [selectedLanguage, setSelectedLanguage] = useState("English");

  const handleCheckboxChange = () => {
    setSelectedLanguage((prevLanguage) =>
      prevLanguage === "English" ? "Japanese" : "English"
    );
  };

  useEffect(() => {
    const timerID = setInterval(() => tick(), 1000);

    const tick = () => {
      const japanDateTime = new Date().toLocaleString("en-US", {
        timeZone: "Asia/Tokyo",
      });
      const japanDateTimeObj = new Date(japanDateTime);

      setJapanTimes(
        `${japanDateTimeObj.getHours() <= 9
          ? "0" + japanDateTimeObj.getHours()
          : japanDateTimeObj.getHours()
        }:${japanDateTimeObj.getMinutes() <= 9
          ? "0" + japanDateTimeObj.getMinutes()
          : japanDateTimeObj.getMinutes()
        }:${japanDateTimeObj.getSeconds() <= 9
          ? "0" + japanDateTimeObj.getSeconds()
          : japanDateTimeObj.getSeconds()
        }`
      );
    };

    return () => {
      clearInterval(timerID);
    };
  }, []);

  return (
    <>
      <Modal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        ariaHideApp={false}
        style={customStyles}
        contentLabel="Nav Bar"
      >
        <nav className="nav menu">
          <ul>
            <li className="bold-and-black">
              <a href="/search">Car Search </a>
            </li>
            <li className="bold-and-black">
              <a
                href="#"
                onClick={() => {
                  if (openSubMenu === "auctions") {
                    setOpenSubMenu("");
                  } else {
                    setOpenSubMenu("auctions");
                  }
                }}
              >
                Auctions <DownIcon style={{ width: 13, height: 8 }} />{" "}
              </a>
              {openSubMenu === "auctions" && (
                <ul className="inner-menu">
                  <li>
                    <a href="/search">All Auctions</a>
                  </li>
                  {/* <li><a href="/LiveAuctions">Live Auction</a></li> */}
                  <li>
                    <a href="/search?auctionType=tender">Tender Auction</a>
                  </li>
                  <li>
                    <a href="/search?auctionType=suggestions">
                      Negotiation Auction
                    </a>
                  </li>
                </ul>
              )}
            </li>
            <li className="bold-and-black">
              <a href="/">Stock</a>
            </li>
            <li className="bold-and-black">
              <a
                href="#"
                onClick={() => {
                  if (openSubMenu === "serivces") {
                    setOpenSubMenu("");
                  } else {
                    setOpenSubMenu("serivces");
                  }
                }}
              >
                SERIVCES <DownIcon style={{ width: 13, height: 8 }} />
              </a>
              {openSubMenu === "serivces" && (
                <ul className="inner-menu">
                  {/* <li>
                    <a href="#">All Auctions</a>
                  </li> */}
                  <li>
                    <a href="/logistics">Logistics Service</a>
                  </li>
                  <li>
                    <a href="/transport">Local Transport Service</a>
                  </li>
                </ul>
              )}
            </li>
            <li className="bold-and-black">
              <a
                href="#"
                onClick={() => {
                  if (openSubMenu === "my page") {
                    setOpenSubMenu("");
                  } else {
                    setOpenSubMenu("my page");
                  }
                }}
              >
                My Page <DownIcon style={{ width: 13, height: 8 }} />
              </a>
              {openSubMenu === "my page" && (
                <ul className="inner-menu">
                  <li>
                    <a href="/my-profile">My Profile </a>
                  </li>
                  <li>
                    <a href="/">Purchase records</a>
                  </li>
                  {/* <li>
                    <a href="/">My Live list</a>
                  </li> */}
                  <li>
                    <a
                      // href="/favourites"
                      onClick={() => user ? navigate("/favourites") : navigate("/login")}
                      style={{ color: 'white' }}
                    >
                      My favorite list
                    </a>
                  </li>
                  <li>
                    <a
                      // href="/tender"
                      onClick={() => user ? navigate("/tender") : navigate("/login")}
                      style={{ color: 'white' }}
                    >
                      My Tender auction
                    </a>
                  </li>
                  <li>
                    <a
                      //  href="/negotiation"
                      onClick={() => user ? navigate("/negotiation") : navigate("/login")}
                      style={{ color: 'white' }}
                    >
                      My Negotiation auction
                    </a>
                  </li>
                </ul>
              )}
            </li>
            <li className="bold-and-black">
              <a href="/">INQUIRY</a>
            </li>
            <li className="bold-and-black">
              <a
                href="#"
                onClick={() => {
                  if (openSubMenu === "about us") {
                    setOpenSubMenu("");
                  } else {
                    setOpenSubMenu("about us");
                  }
                }}
              >
                ABOUT US <DownIcon style={{ width: 13, height: 8 }} />
              </a>
              {openSubMenu === "about us" && (
                <ul className="inner-menu">
                  <li>
                    <a href="/">Overview </a>
                  </li>
                  <li>
                    <a href="/">Company Profile </a>
                  </li>
                  <li>
                    <a href="/">Global Office's </a>
                  </li>
                  <li>
                    <a href="/">Bank Information</a>
                  </li>
                  <li>
                    <a href="/">Team</a>
                  </li>
                  <li>
                    <a href="/">BTC certified agents </a>
                  </li>
                  <li>
                    <a href="/">Why choose BTC</a>
                  </li>
                </ul>
              )}
            </li>
            <div className={user ? "language extend" : "language"}>
              <div className="custom-select">
                <input
                  id="checkbox"
                  type="checkbox"
                  className="checkbox"
                  checked={selectedLanguage === "English"}
                  onChange={handleCheckboxChange}
                />
                <label htmlFor="checkbox" className="switch">
                  <span className="switch__circle">
                    <span className="switch__circle-inner">
                      {selectedLanguage}
                    </span>
                  </span>
                  <span className="switch__left">English</span>
                  <span className="switch__right">Japanese</span>
                </label>
              </div>
            </div>
          </ul>
        </nav>
      </Modal>
      <Copyright isMobile={isMobile} japanDateTime={japanTime} />

      <div className="header">
        <div className="header-content">
          <img
            onClick={() => navigate("/")}
            src={imageBasePath + `${isMobile ? "mobile-logo.png" : "logo.png"}`}
            alt={imageBasePath + "logo.png"}
          />
          <div className="time-list">
            <div className="time-list-upper">
              <div className="time">
                <ClockIcon />
                <p style={{ marginBottom: 0, color: "white" }}>
                  Japan Time {japanTime}
                </p>
              </div>
              <></>
            </div>
            <List />
          </div>
          {!isMobile && (
            <div className="login-mobile">
              <div className="login">
                {user ? (
                  <div className="auth-buttons">
                    {" "}
                    <button className="login-btn">
                      {" "}
                      <UserIcon />
                      {user.firstName} {user.lastName}
                    </button>{" "}
                    <button
                      className="logout-btn"
                      onClick={() => endUserSession()}
                    >
                      {" "}
                      <LogoutIcon style={{ height: 18, width: 18 }} />
                      <span>Logout</span>
                    </button>{" "}
                  </div>
                ) : (
                  <button
                    className="login-btn"
                    onClick={() => {
                      navigate("/login");
                    }}
                  >
                    {" "}
                    <UserIcon />
                    Login/Register
                  </button>
                )}

                <div className="custom-select">
                  <input
                    id="checkbox"
                    type="checkbox"
                    className="checkbox"
                    checked={selectedLanguage === "English"}
                    onChange={handleCheckboxChange}
                  />
                  <label htmlFor="checkbox" className="switch">
                    <span className="switch__circle">
                      <span className="switch__circle-inner">
                        {selectedLanguage}
                      </span>
                    </span>
                    <span className="switch__left">English</span>
                    <span className="switch__right">Japanese</span>
                  </label>
                </div>
              </div>
            </div>
          )}

          {isMobile && (
            <div style={{ display: "flex" }}>
              <button
                style={{ marginRight: 20 }}
                className="login-btn"
              // onClick={() => {
              //   user ? endUserSession() : navigate("/login");
              // }}
              >
                {" "}
                <UserIcon />
                {user ? user.firstName + user.lastName : "Login"}
              </button>{" "}
              <button
                className="hamburger"
                onClick={() => setIsOpen((z) => !z)}
              >
                <i className="fa fa-bars menu-custom" aria-hidden="true" />
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

const Copyright = (props) => {
  return (
    <div className="copyright-bar">
      <div>
        Established 2010{!props.isMobile && <span>, Copyright Reserved</span>}
      </div>
      {props.isMobile && (
        <div>
          {" "}
          <ClockIcon style={{ height: 20, width: 20 }} /> Japan time{" "}
          {props.japanDateTime}
        </div>
      )}
    </div>
  );
};

const List = ({ stats }) => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.user);
  const [showAuctionContent, setShowAuctionContent] = useState(false);

  const handleAuctionClick = () => {
    setShowAuctionContent(!showAuctionContent);
  };

  return (
    <ul style={{ marginTop: "2.3rem" }}>
      <li
        onClick={() => {
          navigate("/search");
        }}
      >
        Car Search
      </li>
      <li>
        <div class="dropdown-s">
          <button style={{ marginRight: 10 }} class="dropbtn-s">
            Auction
          </button>
          <AngleDown />
          <div class="dropdown-content-s">
            <a href="/search">All Auctions</a>
            {/* <a href="/live-auction">Live Auction</a> */}
            <a href="/search?auctionType=tender">Tender Auction</a>
            <a href="/search?auctionType=suggestions">Negotiation Auction</a>
          </div>
        </div>
      </li>
      <li
        onClick={() => {
          navigate("/search");
        }}
      >
        Stock
      </li>
      <li>
        <div class="dropdown-s">
          <button style={{ marginRight: 10 }} class="dropbtn-s">
            Services
          </button>
          <AngleDown />
          <div class="dropdown-content-s">
            <a href="/logistics">Logistics Service</a>
            <a href="/transport">Local Transport Service</a>
          </div>
        </div>
      </li>
      <li>
        <div class="dropdown-s">
          <button style={{ marginRight: 10 }} class="dropbtn-s">
            My Page
          </button>
          <AngleDown />
          <div class="dropdown-content-s">
            <a href="/my-profile">My Profile </a>
            <a href="/login">Purchase records </a>
            {/* <a href="/login">My Live list</a> */}
            <a
              // href="/favourites"
              onClick={() => user ? navigate("/favourites") : navigate("/login")}
              style={{ color: 'black' }}
            >
              My favorite list
            </a>
            <a
              // href="/tender"
              onClick={() => user ? navigate("/tender") : navigate("/login")}
              style={{ color: 'black' }}
            >
              My Tender auction
            </a>
            <a
              //  href="/negotiation"
              onClick={() => user ? navigate("/negotiation") : navigate("/login")}
              style={{ color: 'black' }}
            >
              My Negotiation auction
            </a>
          </div>
        </div>
      </li>

      <li
        onClick={() => {
          navigate("/shipping");
        }}
      >
        Inquiry
      </li>
      <div class="dropdown-s">
        <button style={{ marginRight: 10 }} class="dropbtn-s">
          About us
        </button>
        <AngleDown style={{ color: "white" }} />
        <div class="dropdown-content-s">
          <a href="/">Overview </a>
          <a href="/">Company Profile </a>
          <a href="/">Global Office's </a>
          <a href="/">Bank Information</a>
          <a href="/">Team</a>
          <a href="/">BTC certified agents </a>
          <a href="/">Why choose BTC</a>
        </div>
      </div>
    </ul>
  );
};
